<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="边框粗细">
      <t-input-number size="small" v-model="attribute.lineWidth" :min="1" :max="100" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="半径">
      <t-input-number size="small" v-model="attribute.radius" :min="1" :max="500" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="动态半径">
      <t-input-number size="small" v-model="attribute.activeRadius" :min="1" :max="510" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="显示百分比">
      <t-switch v-model="attribute.showOriginValue"  :label="['数值', '百分比']" size="small"/>
    </t-form-item>
    <t-form-item label="颜色">
      <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
    </t-form-item>
    <t-form-item label="字体颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.fontColor" size="small" />

    </t-form-item>
    
  </t-form>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group.vue";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-dataV-activeRing-option",
  components: {EColorGroup,CptData},
  props: { attribute: Object,cptDataForm:Object, },
}
</script>

<style scoped>
</style>
